import React from 'react';

export default function useColImageSchema({ accessor }) {
    const colDeleteSchema = {
        accessor,
        title: 'Изображение',
        render: ({ row }) => (
            <img
                src={row[accessor]}
                style={{
                    width: '150px',
                    borderRadius: '7px',
                }}
                alt=""
            />
        ),
    };

    return colDeleteSchema;
}
